import { ApiError, post, get } from 'aws-amplify/api';

export const apiGet = async (path, requestBody) => {

  const apiQuery = { 
    apiName: 'Scanseqr',
    path: path
  }

  if (requestBody) {
    apiQuery.options = {
      queryParams: requestBody
    }
  }

  try {
    const { body } = await get(apiQuery).response;
    const response = await body.json();
    window.dispatchEvent(new CustomEvent('maintenance-recovery'));
    return response;
  } catch (error) {
    if (error instanceof ApiError) {
      if (error.response) {
        const { statusCode, headers, body } = error.response;
        if (statusCode === 403 && headers?.['x-maintenance-mode'] === 'true') {
          window.dispatchEvent(new CustomEvent('maintenance-mode'));
          return;
        }
        console.error(`Received ${statusCode} error response with payload: ${body}`);
      }
      // Handle API errors not caused by HTTP response.
      console.error(`Received ${error} error`);
    } else {
      console.error(`An error occurred: ${error}`);
    }
    throw error;
  }
};


export const apiPost = async (path, requestBody) => {
  try {
    const restOperation = post({
      apiName: 'Scanseqr',
      path: path,
      options: {
        body: requestBody
      }
    });

    const { body } = await restOperation.response;
    const response = await body.json();
    window.dispatchEvent(new CustomEvent('maintenance-recovery'));
    return response;
  } catch (error) {
    if (error instanceof ApiError) {
      const { statusCode, headers } = error.response ?? {};
      if (statusCode === 403 && headers?.['x-maintenance-mode'] === 'true') {
        window.dispatchEvent(new CustomEvent('maintenance-mode'));
        return;
      }
      const errorBody = await error.response?.body?.json();
      console.error('API Error:', {
        status: statusCode,
        message: errorBody || error.message
      });
    }
    throw error; // Re-throw to handle in the calling function
  }
}